@if (articleBreadcrumbs) {
  <a class="contentful-article-breadcrumb__item" [routerLink]="articleBreadcrumbs.path">
    {{ articleBreadcrumbs.label }}
  </a>
}
